import React, { useState } from "react";
import { FilePond, registerPlugin } from "react-filepond";
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
//import axios from "axios";
import FileUpladLoader from "./fileUploadLoader";
import api from '../services/api';

// FilePond eklentilerini kaydetme
registerPlugin(FilePondPluginFileValidateType, FilePondPluginImagePreview);

interface FileUploadPopupProps {
    isVisible: boolean;
    onClose: () => void;
    onUploadSuccess: (file: File) => void;
}

const FileUploadPopup: React.FC<FileUploadPopupProps> = ({ isVisible, onClose, onUploadSuccess }) => {
    const [files, setFiles] = useState<File[]>([]);
    const [isUploading, setIsUploading] = useState(false); // Yükleme durumunu takip için

    const handleUpload = async () => {
        if (files.length > 0) {

            const formData = new FormData();
            files.forEach((file) => {
                formData.append("files", file); // Her bir dosyayı ekle
            });

            setIsUploading(true); // Yükleme başladı
            try {
                const response = await api.post("/api/Chat/UploadAnalysis", formData); // API çağrısı
                console.log("API Yanıtı:", response.data);

                // const newMessage = {
                //     sender: 'user',
                //     text: `Dosya başarıyla yüklendi: ${file.name}`, // Dosya adı
                //     time: getTime(),
                //     isFile: true, // Bu mesajın bir dosya olduğunu belirtmek için flag
                //     fileName: file.name, // Dosya adını kaydet
                // };

                // setMessages((prevMessages) => [...prevMessages, newMessage]); // Yeni mesajı ekle

                sessionStorage.setItem('chatGuid', response.data.guid);
                files.forEach(element => {
                    onUploadSuccess(element);
                });

                onClose(); // Popup'ı kapat
            } catch (error) {
                console.error("Yükleme sırasında hata oluştu:", error);
                alert("Dosya yükleme sırasında bir hata oluştu.");
            } finally {
                setIsUploading(false); // Yükleme tamamlandı
                setFiles([]); // Dosya listesini sıfırla
            }
        }
    };

    if (!isVisible) return null;

    return (
        <div className="fullscreen-popup" id="aiChatPopup">
            <div className="popup-content">
                <h3>Hangi Sonuç'a Hoşgeldin</h3>
                {/* <img className="gif" src="/images/ChatAi1.gif" alt="Hoşgeldiniz" /> */}
                <p>Hangi Sonuç ile belgelerini, raporlarını yorumlayabilmesi için lütfen HappAI Dosya yükleme alanına sürükle veya dosyanı seç.</p>

                {/* FilePond Bileşeni */}
                <FilePond
                    files={files}
                    onupdatefiles={(fileItems) => setFiles(fileItems.map((fileItem) => fileItem.file as File))}
                    allowMultiple={false} // Birden fazla dosya istemiyorsanız
                    maxFiles={3} // Maksimum dosya sayısı
                    acceptedFileTypes={["application/pdf", "image/*"]} // Kabul edilen dosya türleri
                    name="file"
                    labelIdle='Sürükle ve Bırak veya Dosya Seç'
                />

                <div className="button-container">
                    <button id="uploadfileclosebtn" className="close-btn" onClick={onClose} disabled={isUploading}>
                        Kapat
                    </button>
                    <button className="btn btn-approve" onClick={handleUpload} disabled={files.length === 0 || isUploading}>
                        {isUploading ? "Yükleniyor..." : "Gönder"}
                    </button>
                </div>

                {isUploading && <FileUpladLoader />}



            </div>
        </div>
    );
};

export default FileUploadPopup;
